import { useEffect, useState } from 'react';
const EXTERNAL_DEPENDENCIES = {
    'cloudinary-upload-widget': 'https://upload-widget.cloudinary.com/global/all.js',
};
const dependencyStatus = {};
export function useRuntimeDependency(dependencyName) {
    const scriptUrl = EXTERNAL_DEPENDENCIES[dependencyName];
    // check if the promise is already set
    let initialStatus = 'loading';
    void dependencyStatus[scriptUrl]?.then((status) => {
        initialStatus = status;
    });
    const [status, setStatus] = useState(initialStatus);
    useEffect(() => {
        const statusPromise = dependencyStatus[scriptUrl];
        if (statusPromise !== undefined) {
            void statusPromise.then(setStatus);
            return;
        }
        dependencyStatus[scriptUrl] = new Promise((resolve) => {
            const updateStatus = (newStatus) => {
                // Notify other instances of the hook
                resolve(newStatus);
                // Notify this hook
                setStatus(newStatus);
            };
            const script = document.createElement('script');
            script.src = scriptUrl;
            script.async = true;
            script.onload = () => {
                updateStatus('ready');
            };
            script.onerror = () => {
                updateStatus('error');
            };
            document.body.appendChild(script);
        });
    }, [scriptUrl]);
    return { status };
}
//# sourceMappingURL=useRuntimeDependency.js.map